<template>
	<Timeline
		v-if="isTimelineEnabled"
		:event="event"
		:mode="timelineMode"
		:elapsed="elapsed"
		:duration="duration"
		:participants="participants"
		:tags="tags"
		:edited-tag="editedTag"
		:is-looking-back="isLookingBack"
		:is-paused="isPaused"
		:is-tagging-tool="isTaggingTool"
		:show-zoom-bar="isTaggingTool"
		@cursor-drag-start="$emit('cursor-drag-start')"
		@cursor-drag-end="$emit('cursor-drag-end')"
		@request-tag-edit="handleRequestTagEdit"
	/>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Timeline from '@components/timeline';
import { transformParticipants } from '@components/timeline/utils';
import { playerBus } from '@videotools/js/events';

export default {
	name:       'TimelineBlock',
	components: { Timeline },
	props:      {
		duration: {
			type:    Number,
			default: 0,
		},
		elapsed: {
			type:    Number,
			default: 0,
		},
		isLookingBack: {
			type:    Boolean,
			default: false,
		},
		isTaggingTool: {
			type:    Boolean,
			default: false,
		},
	},
	data() {
		return {};
	},
	computed: {
		...mapGetters({
			eventTags:             'event/tags',
			streamLeadTimeSeconds: 'event/streamLeadTimeSeconds',
			event:                 'event/event',
			isLive:                'event/isLive',
			editedTag:             'eventTagEdit/timelineSelectedTag',
			isTimelineEnabled:     'features/isTimelineEnabled',
			eventTaggingToolTags:  'timelineTags/activeTags',
			isPaused:              'player/isPaused',
			preferences:           'sharedUser/preferences',
		}),
		noSpoilerMode() {
			return this.preferences?.noSpoilerMode ?? false;
		},
		participants() {
			return transformParticipants(this.event?.participants);
		},
		timelineMode() {
			if (!this.isTaggingTool) {
				return 'view';
			}
			if (this.editedTag && !this.editedTag.isOutsideVideo) {
				return 'edit';
			}
			return 'normal';
		},
		tags() {
			// In player, hide timeline tags when no-spoiler mode is on (filtering downstream)
			if (!this.isTaggingTool && this.noSpoilerMode) {
				return [];
			}
			return (this.isTaggingTool ? this.eventTaggingToolTags : this.eventTags).map(e => {
				const time = e.timestamp;
				const participant = (e.participant && e.participant.id) || (e.team && e.team.id) || (e.player && e.player.id);
				return {
					id:    e.id,
					name:  e.name,
					image: e.imageUrl,
					participant,
					time,
					tag:   e,
				};
			// filter out "future" tags in player timeline during live (when stream is behind incoming tags via API)
			}).filter(e => (this.isTaggingTool || !this.isLive) ? true : e.tag.timestamp < playerBus.mediaDuration - this.streamLeadTimeSeconds);
		},

	},
	methods: {
		...mapActions({
			updateEventTag: 'event/updateEventTag',
			editEventTag:   'eventTagEdit/editEventTag',
		}),
		handleRequestTagEdit(tag) {
			this.editEventTag(tag);
		},

	},
};
</script>
